//#region Imports

import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Editor } from 'primeng/editor';
import { ClassForm } from '../../../../../shared/models/interfaces/forms/course-form.interface';

//#endregion

@Component({
  selector: 'l-course-content-type-text-editor',
  standalone: true,
  templateUrl: './course-content-type-text-editor.component.html',
  imports: [ReactiveFormsModule, Editor],
})
export class CourseContentTypeTextEditorComponent {

  //#region Inputs

  @Input({ required: true })
  public form!: FormGroup<ClassForm>;

  //#endregion

}
